module.exports = __webpack_public_path__ + "static/img/mocha.084768f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skills/mocha.jpg
// module id = 520
// module chunks = 1